/**
 * Resolve a backend-relative file path (recordings, certificates, handbooks, …)
 * to an absolute URL. External `http(s)` paths pass through unchanged.
 * Mirrors the `getFileUrl` helper used across the CLASSIC Student Portal.
 */
export function resolveBackendFileUrl(path?: string | null): string {
  if (!path) return '#';
  if (/^https?:\/\//i.test(path)) return path;
  const base =
    (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/api\/v\d+\/?$/, '') ||
    'http://localhost:5050';
  return `${base}/${path.replace(/^\/+/, '')}`;
}
